import React from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import redefining_project1 from "../assests/Images/Redefining_Project1.jpg";
import Redefining_Project2 from "../assests/Images/Redefining_Project2.jpg";
import redefining_project2 from "../assests/Images/Redefining_Project2.jpg";
import { Link } from "react-router-dom";
import { LuNewspaper } from "react-icons/lu";
import orsac from "../assests/Images/ORSAC_Project.jpg";
import revolution1 from "../assests/Images/RevolutionizingSales_Project1.jpg";
import revolution2 from "../assests/Images/RevolutionizingSales_Project2.jpg";
import Lean_Transformation1 from "../assests/Images/Lean_Transformation1.jpg";
import Lean_Transformation2 from "../assests/Images/Lean_Transformation2.jpg";
import WaveEffect from "../Components/WaveEffect";

const LeanTransformationProject = () => {
  return (
    <div>
      <Navbar />
      <div
        className="bg-cover bg-center h-[50vh]  lg:h-[75vh] md:h-[500px] sm:h-[400px] rounded-tl-[390px]"
        style={{ backgroundImage: `url(${Lean_Transformation2})` }}
      >
        <div className="h-full bg-black bg-opacity-80 w-full flex flex-col justify-center items-center sm:rounded-tl-[390px] lg:rounded-tl-[390px]">
          <WaveEffect
            text="Redefining Productivity Incentives"
            textClassName="text-white text-xl lg:text-5xl xl:text-5xl 2xl:text-3xl sm:text-3xl 2xl:text-8xl font-bold"
          />
          <div className="h-1 lg:h-2 xl:h-2 2xl:h-2 mt-4 w-24 bg-white" />
        </div>
      </div>

      <div className="m-10 xl:m-28 lg:m-20 md:m-16 sm:m-10 flex flex-col xl:flex-row lg:flex-row md:flex-col sm:flex-col gap-20 h-full sm:mt-10 ">
        <div className="w-full  ">
          <img
            src={Lean_Transformation1}
            alt=""
            className="lg:h-[35rem] lg:w-full h-full w-full rounded-xl object-cover"
          />
        </div>

        <div className="flex justify-center">
          <div className="w-[35rem] h-fit shadow-lg p-10 md:w-[25rem]  sm:w-[20rem]  place-items-center ">
            <div className="flex flex-row gap-2 justify-start items-center border-b-2 border-gray-300">
              <LuNewspaper className="text-2xl text-primary" />
              <h1 className="text-2xl font-bold pb-4 text-center">
                Recent Case Studies
              </h1>
            </div>

            <div className="flex flex-row gap-3 border-b-2 border-gray-300 py-5">
              <img
                src={orsac}
                alt=""
                className=" h-14 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">April 3, 2025</h1>
                <Link to="/orsac-project" className="hover:text-primary">
                  <p className="font-semibold text-lg">ORSAC project</p>
                </Link>
              </div>
            </div>

            <div className="flex flex-row gap-3 border-b-2 border-gray-300 py-5">
              <img
                src={revolution2}
                alt=""
                className=" h-16 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">September 9, 2020</h1>
                <Link
                  to="/redefining-productivity-incentives"
                  className="hover:text-primary"
                >
                  <p className="font-semibold text-lg">
                    Redefining Productivity Incentives
                  </p>
                </Link>
              </div>
            </div>

            <div className="flex flex-row gap-3 py-5">
              <img
                src={redefining_project2}
                alt=""
                className="h-14 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">September 9, 2020</h1>
                <Link
                  to="/revolutionizing-sales-operations"
                  className="hover:text-primary"
                >
                  <p className="font-semibold text-lg">
                    Revolutionizing Sales Operations
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col justify-center items-center text-start gap-10 px-16 text-lg mb-20">
        <p>
          <span className="font-semibold text-primary">The Challenge:</span>{" "}
          Ganges Internationale, a key player in the solar energy sector, was
          grappling with productivity issues and poor quality that threatened to
          derail its export commitments. The stakes were high—delays and defects
          were unacceptable in a market where precision and timeliness are
          paramount.
        </p>
        <p>
          <span className="font-semibold text-primary">
            The Decisive Intervention:{" "}
          </span>{" "}
          Recognizing the critical need for a turnaround, Ganges Internationale
          brought us on board. With a reputation for delivering transformative
          results, we knew that a comprehensive approach was required. Our team
          implemented a Lean Manufacturing overhaul, starting with a Gemba walk
          to identify waste (muda) and inefficiencies on the shop floor. We
          didn’t stop there; we also re-engineered the production lines and
          established Standard Operating Procedures (SOPs) displayed on Andon
          boards to ensure consistent quality and efficiency.
        </p>
        <p>
          <span className="font-bold text-primary">The Solution:</span> Our Lean
          Manufacturing program was meticulous and effective. By re-laying out
          the production lines and implementing 5S+1 practices, we created a
          more organized, productive workspace. The focus on continuous
          improvement through root cause analysis and real-time monitoring led
          to significant enhancements in both productivity and quality.
        </p>
        <p>
          <span className="font-semibold text-primary">The Outcome:</span> The
          results were transformative. Large amounts of scrap were sold, freeing
          up valuable floor space and improving the work environment. On-time
          delivery rates soared, and the company’s reputation for quality and
          reliability was restored. Ganges Internationale not only met its
          export commitments but did so with a renewed confidence in its
          operational capabilities, solidifying its standing in the global
          market.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default LeanTransformationProject;
